import { Vec2 } from "../../models/SyntheticMap";

export enum DetectedObjectType {
  UKNOWN = 0,
  HUMAN = 1,
  HUMAN_WITH_JOINTS = 2,
}

export enum PoseLandmarks {
  NOSE = 0,
  LEFT_EYE = 1,
  RIGHT_EYE = 2,
  LEFT_EAR = 3,
  RIGHT_EAR = 4,
  LEFT_SHOULDER = 5,
  RIGHT_SHOULDER = 6,
  LEFT_ELBOW = 7,
  RIGHT_ELBOW = 8,
  LEFT_WRIST = 9,
  RIGHT_WRIST = 10,
  LEFT_HIP = 11,
  RIGHT_HIP = 12,
  LEFT_KNEE = 13,
  RIGHT_KNEE = 14,
  LEFT_ANKLE = 15,
  RIGHT_ANKLE = 16,
  END = 17,
}

export class DetectedObject {
  public type: DetectedObjectType = DetectedObjectType.UKNOWN;
  public id = 0;
  public leftUpper: Vec2 = { x: 0, y: 0 };
  public rightLower: Vec2 = { x: 0, y: 0 };
  public bearing: number = 0;
  public distance: number = 0;
  public direction: number = 0;
  public name: string = '';
  constructor() { }
  public read(data: Int16Array, offset: number): number {
    // console.log('reading object from data: ', data.length, ' offset: ', offset);
    this.type = data[offset];
    this.id = data[offset + 1];
    this.leftUpper.x = data[offset + 2];
    this.leftUpper.y = data[offset + 3];
    this.rightLower.x = data[offset + 4];
    this.rightLower.y = data[offset + 5];
    this.bearing = data[offset + 6];
    this.distance = data[offset + 7];
    return offset + 8;
  }
}

export class PersonWithJoints extends DetectedObject {
  public gesture = 0;
  public landmarks: Vec2[] = [];
  constructor() {
    super();
    for (let i = 0; i < PoseLandmarks.END; i++) {
      this.landmarks.push({ x: 0, y: 0 });
    }
  }

  public hasLandmarks(...l: PoseLandmarks[]): boolean {
    for (const i of l) {
      if (this.landmarks[i].x === 0 && this.landmarks[i].y === 0) {
        return false;
      }
    }
    return true;
  }

  public read(data: Int16Array, offset: number): number {
    offset = super.read(data, offset);
    this.gesture = data[offset];
    for (let i = 0; i < PoseLandmarks.END; i++) {
      this.landmarks[i].x = data[offset + 1 + i * 2];
      this.landmarks[i].y = data[offset + 2 + i * 2];
    }
    const value = data[offset + 35];
    this.direction = (typeof value === 'number' && !isNaN(value)) ? value / 100.0 : 0;
    return offset + 36;
  }
}

export class ObjectDetectionReport {
  public detectedObjects: DetectedObject[] = [];
  constructor() { }
  public read(data: Int16Array): void {
    this.detectedObjects = [];
    if (data.length < 8) {
      return;
    }
    let offset = 0;
    while (offset < data.length) {
      const c = data[offset];
      let object: DetectedObject;
      if (c === DetectedObjectType.HUMAN) {
        object = new DetectedObject();
      } else if (c === DetectedObjectType.HUMAN_WITH_JOINTS) {
        object = new PersonWithJoints();
      } else {
        object = new DetectedObject();
      }
      offset = object.read(data, offset);
      // const metaData = actor.objectDetectionMetadata.persons.find(p => p.id === object.id);
      // if (metaData) {
      //   object.name = metaData.name;
      // }
      // console.log('read object: ', object, ' offset: ', offset);
      this.detectedObjects.push(object);
    }
  }
}